import { Alert, Box, TextField } from "@mui/material";

export default function CampoCorreoProveedor({
  emailMaestro = "",
  emailManual = "",
  onEmailManualChange,
  errorEmail = "",
  disabled = false,
  helperText,
  sx,
}) {
  if (emailMaestro) {
    return (
      <Alert severity="info" sx={{ mt: 2, ...sx }}>
        Se notificará al correo registrado:{" "}
        <Box component="span" sx={{ fontWeight: 600 }}>
          {emailMaestro}
        </Box>
      </Alert>
    );
  }

  return (
    <TextField
      fullWidth
      required
      type="email"
      label="Correo del proveedor"
      placeholder="proveedor@ejemplo.com"
      value={emailManual}
      onChange={(e) => onEmailManualChange?.(e.target.value)}
      disabled={disabled}
      error={Boolean(errorEmail)}
      helperText={errorEmail || helperText}
      FormHelperTextProps={
        errorEmail
          ? undefined
          : { sx: { color: "text.primary", fontWeight: 600 } }
      }
      sx={{ mt: 2, ...sx }}
    />
  );
}
